import React from 'react';
import Reveal from './Reveal';
import { photos } from '../photos';

export default function Grocery({ t }) {
  const g = t.grocery;

  return (
    <section id="grocery" className="scroll-mt-24 bg-cream py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <Reveal>
            <p className="font-display text-xs tracking-[0.32em] uppercase text-ember">06 — {g.kicker}</p>
            <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl leading-[0.92]">{g.title}</h2>
            <p className="mt-5 text-stone leading-relaxed">{g.sub}</p>
            <div className="mt-8 h-72 overflow-hidden bg-pine">
              <img src={photos.market} alt={t.media.market} className="w-full h-full object-cover" />
            </div>
          </Reveal>
        </div>

        <ol className="lg:col-span-7 flex flex-col">
          {g.steps.map((step, i) => (
            <Reveal key={i} delay={(i % 3) * 60}>
              <li className="grid grid-cols-[64px_1fr] gap-4 py-6 border-b border-ink/10">
                <span className="font-display text-4xl text-ember leading-none">{String(i + 1).padStart(2, '0')}</span>
                <p className="text-lg leading-relaxed pt-1">{step}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
